@if(isChildRoute){
    <router-outlet></router-outlet>
    }
    @else {
    <hr />
    <div class="quicksight-lists-container">
        @for (item of quickSightResourceList; track $index) {
        <a class="quicksight-resource" [routerLink]="item.url">{{item.name}}</a>
        }
    </div>
    }